export default [
    {
        path: "/admin/phum-villages",
        name: "phum-village",
        meta: true,
        component: () => import("@/pages/corporate/phum-village/index.vue")
    },
];
